import { URLS } from '@/constants/urls';

export const ATTRIBUTES = {
  CONDITIONING: 'conditionnement',
  COUNTRY: 'pays',
  REGION: 'region',
  COLOR: 'couleur',
  RIBBONAD: 'ribbonad',
  ENVIRONNEMENT: 'environnement',
  PRODUCER: 'producteur',
  IN_STOCK: 'in_stock',
  APPELLATION: 'appellation',
  NB_UNIT: 'nbUnit',
  ALCOOL: 'alcool',
  GRAPE_VARIETY: 'cepage',
  RATING: 'classement',
  PACKAGING: 'packaging',
  PRE_ARRIVAL: 'prearrival_o_n',
  QTY_MAX: 'qte_vte_max',
  WINEBOX: 'winebox_o_n',
  FORMAT: 'format',
  EQVL_BTL: 'equivbtl',
  DECLINATION: 'declinaison',
  PROMOTION: 'promotion',
  LIMIT_EQUIVBTL: 'limit_equivbtl',
  TYPE_PRODUIT: 'type_produit',
  INFO_SITE: 'infoSite',
  MILLESIME: 'millesime',
  ORIGINE_SPIRITUEUX: 'origine_spiritueux',
  MATIERE_PREMIERE: 'matiere_premiere',
  MENTION_AGE: 'mention_age',
  SOUS_TYPE_PRODUIT: 'sous_type_produit',
  PROMO_INCENTIVE: 'promo_incentive'
};

export const AVAILABILITY = {
  LABEL: {
    AVAILABLE: 'available',
    IN_STOCK_SHOP: 'inStockShop',
    LATER: 'unavailable',
    PREARRIVAL: 'prearrival',
    PRIMEUR: 'primeur'
  },
  LETTERS: {
    IN_STOCK: 'L',
    PRIMEUR: 'P',
    PREARRIVAL: 'PA'
  }
};

export const BONUS_TYPES = {
  IMAGE: 'image',
  BONUS: 'bonus',
  VIDEO: 'video'
};

export const BOX_TYPE = {
  STANDARD: 'C',
  BOTTLE_CASE: 'CE',
  CARDBOARD_BOX: 'CC'
};

export const CONDITIONNEMENT_GIFTCARD_ACCESSORIES = ['X', 'X1', 'X2', 'X3', 'X4', 'X5'];

export const ENVIRONNEMENT = {
  AGRIBIO: '1',
  DEMETER: '2',
  HVE: '3',
  BIODYVIN: '6'
};

export const ENVIRONNEMENT_DATA = {
  [ENVIRONNEMENT.AGRIBIO]: {
    src: {
      icon: URLS.AGRIBIO_ICON,
      circleIcon: URLS.BIO_CIRCLE_ICON
    },
    name: 'bioLabel.organic.name',
    desc: 'bioLabel.organic.desc',
    href: 'bioLabel.organic.url'
  },
  [ENVIRONNEMENT.BIODYVIN]: {
    src: {
      icon: URLS.BIODYVIN_ICON,
      circleIcon: URLS.BIO_CIRCLE_ICON
    },
    name: 'bioLabel.biodyvin.name',
    desc: 'bioLabel.biodyvin.desc',
    href: 'bioLabel.biodyvin.url'
  },
  [ENVIRONNEMENT.DEMETER]: {
    src: {
      icon: URLS.DEMETER_ICON,
      circleIcon: URLS.BIO_CIRCLE_ICON
    },
    name: 'bioLabel.demeter.name',
    desc: 'bioLabel.demeter.desc',
    href: 'bioLabel.demeter.url'
  },
  [ENVIRONNEMENT.HVE]: {
    src: {
      icon: URLS.HVE_ICON,
      circleIcon: URLS.HVE_CIRCLE_ICON
    },
    name: 'bioLabel.hve.name',
    desc: 'bioLabel.hve.desc',
    href: 'bioLabel.hve.url'
  }
};

// For 'primeurs'
export const FUTURES = ['Futures', 'Subskriptionsweine', 'Primeur'];

export const GET_STOCK = {
  SHORT: 'V2',
  FULL: 'V3'
};

export const LANDING = {
  KRUG: 'krug',
  WHISPERING: 'whispering-angel'
};

export const SEPARATOR = {
  FILTER_VALUE: ':',
  FILTER_ELEMENT: '|',
  CATEG_DECL: ';',
  STORE: '_'
};

export const TYPE_PRODUIT = {
  WHISKY: '32',
  COGNAC: '24',
  ARMAGNAC: '22',
  GIN: '25',
  RHUM: '26',
  TEQUILA: '69',
  VODKA: '31',
  EAUX_DE_VIE: '2'
};
